
import { mapActions, mapGetters } from "vuex";
import { defineComponent } from "vue";
import OtherCarInfo from "@/cars/OtherCarInfo.vue";
import SelectingCar from "@/cars/SelectingCar.vue";
import SelectedCar from "@/cars/SelectedCar.vue";
import SelectedCarPlaceholder from "@/cars/SelectedCarPlaceholder.vue";
import Registration from "@/accounts/Registration.vue";

interface SelectedCarData {
  addingNext: Boolean;
  isRegistration: Boolean;
}

export default defineComponent({
  data(): SelectedCarData {
    return {
      addingNext: false,
      isRegistration: false,
    };
  },
  mounted() {
    this.pullCars();
  },
  methods: {
    ...mapActions("cars", ["pullCars"]),
    addNextCar() {
      this.addingNext = true;
    },
    selectionFinished() {
      this.addingNext = false;
    },
    needRegistration() {
      this.isRegistration = true;
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar", "isCarsLoading"]),
  },
  components: {
    Registration,
    SelectedCarPlaceholder,
    SelectedCar,
    SelectingCar,
    OtherCarInfo,
  },
});
